<template>
  <div>
    <el-dialog
      :visible.sync="isShown"
      v-loading="isLoading"
      custom-class="simulation-modal"
      top="7vh"
      :close-on-click-modal="false"
      :modal-append-to-body="false">
      <div>
        <el-form ref="form">
          <div class="calc">
            <el-row :gutter="5" align="middle">
              <el-col :offset="1" :span="6">
                <div class="ratio-input">
                  <span class="sales-ratio">前年売上<span class="multiplier">×</span></span>
                  <el-input v-model="form.salesPercentage" :disabled="salesSelected"></el-input>％
                </div>
              </el-col>
              <el-col :span="6">
                <div class="ratio-input">
                  <span class="person-ratio">前年客数<span class="multiplier">×</span></span>
                  <el-input v-model="form.personPercentage" :disabled="personSelected"></el-input>％
                </div>
              </el-col>
              <el-col :span="6">
                <div class="ratio-input">
                  <span class="person-sales-ratio">前年客単価<span class="multiplier">×</span></span>
                  <el-input v-model="form.personSalesPercentage" :disabled="personSalesSelected"></el-input>%
                </div>
              </el-col>
              <el-col :offset="1" :span="3">
                <el-tooltip placement="top-start">
                  <div slot="content">
                    前年度の数値を元に「予算」に数値を反映させます。<br>
                    値を増減させたい場合はパーセンテージを調整してください。<br>
                    チェックボックスを入れた行だけが再計算の対象になります。
                  </div>
                  <el-button @click="calculate">再計算</el-button>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row>
              <el-col :offset="1" :span="6">
                <div class="sales-ratio-radio">
                  <el-tooltip placement="bottom" content="客数と客単価から売上を算出します">
                    <el-radio v-model="form.autoValue" label="sales" border size="mini">自動</el-radio>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="person-ratio-radio">
                  <el-tooltip placement="bottom" content="売上と客単価から客数を算出します">
                    <el-radio v-model="form.autoValue" label="person" border size="mini">自動</el-radio>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="person-sales-ratio-radio">
                  <el-tooltip placement="bottom" content="売上と客数から客単価を算出します">
                    <el-radio v-model="form.autoValue" label="personSales" border size="mini">自動</el-radio>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="5" align="middle">
            </el-row>
          </div>
          <div class="simulation">
            <el-row :gutter="5" align="middle">
              <el-col :span="1">
                <el-tooltip placement="top" content="全て選択／全て解除">
                  <el-checkbox @change="handleCheckAll" v-model="form.checkAll" :indeterminate="form.isIndeterminate"></el-checkbox>
                </el-tooltip>
              </el-col>
              <el-col :offset="2" :span="9" class="simulation-grand-header">前年</el-col>
              <el-col :offset="1" :span="9" class="simulation-grand-header">予算</el-col>
            </el-row>
            <el-row :gutter="5" align="middle">
              <el-col :offset="3" :span="3" class="simulation-header">売上</el-col>
              <el-col :span="3" class="simulation-header">客数</el-col>
              <el-col :span="3" class="simulation-header">客単価</el-col>
              <el-col :offset="1" :span="3" class="simulation-header">売上</el-col>
              <el-col :span="3" class="simulation-header">客数</el-col>
              <el-col :span="3" class="simulation-header">客単価</el-col>
            </el-row>
            <el-row :gutter="5" align="middle" v-for="label, index in labels" :key="label">
              <el-col :span="1"><el-checkbox v-model="form.targetWeekday" @change="handleTargetWeekdayChange" :label="label">&nbsp;</el-checkbox></el-col>
              <el-col :span="1" class="simulation-data-header">{{ weekdayLabel[label] }}</el-col>
              <el-col :offset="1" :span="3" class="simulation-data-body prev-sales">{{ prevData[label].sales|addFigure }}</el-col>
              <el-col :span="3" class="simulation-data-body prev-person">{{ prevData[label].person|addFigure }}</el-col>
              <el-col :span="3" class="simulation-data-body prev-person-sales">{{ prevData[label].personSales|addFigure }}</el-col>
              <el-col :offset="1" :span="3" class="simulation-data-body">
                <el-input
                  v-model="form[label].sales"
                  v-on:keydown.native.enter.prevent="nextFocus"
                  v-on:keydown.native.tab.prevent="nextFocus"
                  @change="handleChangeSales(form[label])"
                  @focus="handleFocusIn($event, label, 'sales')"
                  @focusout.native="handleFocusOut(label, 'sales')"
                  :tabindex="String((index * 3) + 101)"
                  :disabled="salesSelected">
                </el-input>
              </el-col>
              <el-col :span="3" class="simulation-data-body">
                <el-input
                  v-model="form[label].person"
                  v-on:keydown.native.enter.prevent="nextFocus"
                  v-on:keydown.native.tab.prevent="nextFocus"
                  @change="handleChangePerson(form[label])"
                  @focus="handleFocusIn($event, label, 'person')"
                  @focusout.native="handleFocusOut(label, 'person')"
                  :tabindex="String((index * 3) + 102)"
                  :disabled="personSelected">
                </el-input>
              </el-col>
              <el-col :span="3" class="simulation-data-body person-sales">
                <el-input
                  v-model="form[label].personSales"
                  v-on:keydown.native.enter.prevent="nextFocus"
                  v-on:keydown.native.tab.prevent="nextFocus"
                  @change="handleChangePersonSales(form[label])"
                  @focus="handleFocusIn($event, label, 'personSales')"
                  @focusout="handleFocusOut(label, 'personSales')"
                  :tabindex="String((index * 3) + 103)"
                  :disabled="personSalesSelected">
                </el-input>
              </el-col>
            </el-row>
            <el-row :gutter="5" align="middle"
            <div class="btn-area">
              <el-tooltip placement="bottom" content="入力された値を予算画面に反映します。空白，0円は無視されます。">
                <el-button style="width: 200px;" @click="submit">登録</el-button>
              </el-tooltip>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import $ from 'jquery'
import addFigure from '@/misc/addFigure'
import removeFigure from '@/misc/removeFigure'
import {mapGetters} from 'vuex'

const defaultFormData = {
  targetWeekday: [],
  salesPercentage: 100,
  personPercentage: 100,
  personSalesPercentage: 100,
  autoValue: 'personSales',
  isIndeterminate: false,
  checkAll: false,
  mon: {
    sales: '',
    person: '',
    personSales: '',
  },
  tue: {
    sales: '',
    person: '',
    personSales: '',
  },
  wed: {
    sales: '',
    person: '',
    personSales: '',
  },
  thu: {
    sales: '',
    person: '',
    personSales: '',
  },
  fri: {
    sales: '',
    person: '',
    personSales: '',
  },
  sat: {
    sales: '',
    person: '',
    personSales: '',
  },
  sun: {
    sales: '',
    person: '',
    personSales: '',
  },
  bho: {
    sales: '',
    person: '',
    personSales: '',
  },
  hol: {
    sales: '',
    person: '',
    personSales: '',
  },
}
const defaultPrevData = {
  mon: {
    sales: '',
    person: '',
    personSales: '',
  },
  tue: {
    sales: '',
    person: '',
    personSales: '',
  },
  wed: {
    sales: '',
    person: '',
    personSales: '',
  },
  thu: {
    sales: '',
    person: '',
    personSales: '',
  },
  fri: {
    sales: '',
    person: '',
    personSales: '',
  },
  sat: {
    sales: '',
    person: '',
    personSales: '',
  },
  sun: {
    sales: '',
    person: '',
    personSales: '',
  },
  bho: {
    sales: '',
    person: '',
    personSales: '',
  },
  hol: {
    sales: '',
    person: '',
    personSales: '',
  },
}

export default {
  name: 'SalesBudgetSimulationModal',
  data () {
    let ret = {
      rounding: null,
      isShown: false,
      isLoading: false,
      labels: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun', 'bho', 'hol'],
      weekdayLabel: {
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fri: '金',
        sat: '土',
        sun: '日',
        bho: '祝前日',
        hol: '祝日',
      },
    }
    ret.form = _.cloneDeep(defaultFormData)
    ret.prevData = _.cloneDeep(defaultPrevData)
    return ret
  },
  computed: {
    ...mapGetters('report', ['roundingFunction']),
    salesSelected () {
      return this.form.autoValue === 'sales'
    },
    personSelected () {
      return this.form.autoValue === 'person'
    },
    personSalesSelected () {
      return this.form.autoValue === 'personSales'
    },
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
  },
  methods: {
    show (data) {
      this.reset()
      this.setPrevData(data)
      this.isShown = true
    },
    reset () {
      this.form = _.cloneDeep(defaultFormData)
    },
    handleFocusIn (e, label, key) {
      this.form[label][key] = removeFigure(this.form[label][key])
      this.$nextTick(() => {
        e.target.select()
      })
    },
    handleFocusOut (label, key) {
      this.form[label][key] = addFigure(this.form[label][key])
    },
    handleChangeSales (data) {
      const sales = removeFigure(data.sales)
      const personSales = removeFigure(data.personSales)
      const person = removeFigure(data.person)
      if (this.form.autoValue === 'person' && personSales) {
        data.person = addFigure(this.rounding(sales / personSales))
      } else if (this.form.autoValue === 'personSales' && person) {
        data.personSales = addFigure(this.rounding(sales / person))
      }
      this.setEmpty(data)
    },
    handleChangePerson (data) {
      const sales = removeFigure(data.sales)
      const personSales = removeFigure(data.personSales)
      const person = removeFigure(data.person)
      if (this.form.autoValue === 'sales') {
        data.sales = addFigure(person * personSales)
      } else if (this.form.autoValue === 'personSales' && person) {
        data.personSales = addFigure(this.rounding(sales / person))
      }
      this.setEmpty(data)
    },
    handleChangePersonSales (data) {
      const sales = removeFigure(data.sales)
      const personSales = removeFigure(data.personSales)
      const person = removeFigure(data.person)
      if (this.form.autoValue === 'sales') {
        data.sales = addFigure(person * personSales)
      } else if (this.form.autoValue === 'person' && personSales) {
        data.person = addFigure(this.rounding(sales / personSales))
      }
      this.setEmpty(data)
    },
    setEmpty (data) {
      if (!data.sales || data.sales === '0' || isNaN(removeFigure(data.sales))) {
        data.sales = ''
      }
      if (!data.person || data.person === '0' || isNaN(removeFigure(data.person))) {
        data.person = ''
      }
      if (!data.personSales || data.personSales === '0' || isNaN(removeFigure(data.personSales))) {
        data.personSales = ''
      }
    },
    setPrevData (data) {
      console.log(Object.keys(this.prevData))
      const labels = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'hol', 'bho']
      let prevData = {}
      let prevCount = {}
      labels.forEach(key => {
        prevData[key] = {
          sales: 0,
          person: 0,
          personSales: 0,
        }
        prevCount[key] = 0
      })
      data.forEach(item => {
        const weekday = moment(item.date).weekday()
        const key = item.isHoliday ? 'hol' : (item.isBeforeHoliday ? 'bho' : labels[weekday])
        console.log(item)
        if (item.prevSales === 0) {
          return true
        }
        prevData[key].sales += item.prevSales
        prevData[key].person += item.prevPerson
        prevData[key].personSales += item.prevSalesPerson
        prevCount[key]++
      })

      labels.forEach(key => {
        if (prevCount[key] === 0) {
          this.prevData[key].sales = 0
          this.prevData[key].person = 0
          this.prevData[key].personSales = 0
        } else {
          this.prevData[key].sales = this.rounding(prevData[key].sales / prevCount[key])
          this.prevData[key].person = this.rounding(prevData[key].person / prevCount[key])
          this.prevData[key].personSales = this.rounding(prevData[key].personSales / prevCount[key])
        }
      })
    },
    calculate () {
      this.form.targetWeekday.forEach(k => {
        const prevData = this.prevData[k]
        const data = this.form[k]
        if (this.form.autoValue === 'sales') {
          data.person = this.rounding(prevData.person * this.form.personPercentage / 100)
          data.personSales = this.rounding(prevData.personSales * this.form.personSalesPercentage / 100)
          data.sales = data.person * data.personSales
        } else if (this.form.autoValue === 'person') {
          data.sales = this.rounding(prevData.sales * this.form.salesPercentage / 100)
          data.personSales = this.rounding(prevData.personSales * this.form.personSalesPercentage / 100)
          data.person = data.personSales ? this.rounding(data.sales / data.personSales) : 0
        } else {
          data.sales = this.rounding(prevData.sales * this.form.salesPercentage / 100)
          data.person = this.rounding(prevData.person * this.form.personPercentage / 100)
          data.personSales = data.person ? this.rounding(data.sales / data.person) : 0
        }
        data.sales = addFigure(data.sales)
        data.person = addFigure(data.person)
        data.personSales = addFigure(data.personSales)
        this.setEmpty(data)
      })
    },
    submit () {
      let data = {}
      Object.keys(this.form).forEach(k => {
        const tmp = this.form[k]
        if (!tmp.sales && !tmp.person && !tmp.personSales) {
          return true
        }
        data[k] = {}
        if (tmp.sales) {
          data[k].sales = removeFigure(tmp.sales)
        }
        if (tmp.person) {
          data[k].person = removeFigure(tmp.person)
        }
        if (tmp.personSales) {
          data[k].personSales = removeFigure(tmp.personSales)
        }
      })
      console.log(data)
      this.$emit('register', data)
      this.isShown = false
    },
    handleCheckAll (val) {
      if (val) {
        this.form.targetWeekday = [...this.labels]
      } else {
        this.form.targetWeekday = []
      }
      this.form.isIndeterminate = false
    },
    handleTargetWeekdayChange (val) {
      const cnt = this.form.targetWeekday.length
      this.form.checkAll = cnt === 9
      this.form.isIndeterminate = cnt > 0 && cnt < 9
    },
    nextFocus (event) {
      let tabIndex = event.target.tabIndex + 3

      let element = $(this.$el).find('input[tabindex=' + tabIndex + ']')
      if (element.length === 0) {
        element = $(this.$el).find('input[tabindex=' + (event.target.tabIndex % 3 + 1) + ']')
      }
      if (element.length) {
        element[0].focus()
      }
    },
  },
}
</script>
<style>
.simulation-modal {
  width: 1000px;
  height: auto;
  padding: 15px 0;
  background-color: #F8F8F8;
  border-radius: 2px;
  box-shadow: 0 0 20px rgba(0,0,0,0.6);
}
.simulation-modal* {
  box-sizing: border-box;
  font-size: 14px;
}
.simulation-modal*:before,
.simulation-modal*:after {
  box-sizing: border-box;
}

.simulation-modal .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 20px;
}

.multiplier {
  content: '×';
  padding: 0 4px;
  font-size: 14px;
}

.sales-ratio,
.person-ratio,
.person-sales-ratio {
  display: inline-block;
}

.sales-ratio-radio,
.person-ratio-radio {
  padding-left: 80px;
}

.person-sales-ratio-radio {
  padding-left: 95px;
}
 
.ratio-input .el-input {
  width: 50%;
  height: 30px;
}

.ratio-input .el-input__inner {
  height: 30px;
  text-align: right;
}

.simulation-data-body .el-input__inner {
  height: 30px;
  padding: 0 8px;
  border: 1px solid #D5D5D5;
  box-shadow: inset 1px 1px 0 0 rgba(0,0,0,0.05);
  border-radius: 3px;
  text-align: right;
  line-height: 28px;
  font-size: 16px;
  color: #555;
}
</style>

<style scoped>
.simulation-grand-header {
  height: 25px;
  line-height: 25px;
  font-weight: bold;
  text-align: center;
}

.simulation-header {
  text-align: center;
}

.simulation-data-header {
  text-align: center;
  padding-right: 10px;
  white-space: nowrap;
}

.simulation-data-body {
  text-align: right;
}

.calc {
  width: 100%;
  height: auto;
  padding: 10px 30px;
  overflow: hidden;
}
.calc fieldset,
.calc button {
  float: left;
}
.calc fieldset {
  width: 28%;
  height: auto;
  overflow: hidden;
  border: none;
  line-height: 30px;
}
.calc fieldset label,
.calc fieldset input {
  width: 40%;
  height: 30px;
  float: left;
}
.calc fieldset label:not(.auto):after {
  content: '×';
  padding: 0 4px;
  font-size: 14px;
}
input[type="text"] {
  margin: 0 4px 0 0;
  padding: 8px 10px;
  border: 1px solid #DDD;
  border-radius: 3px;
  box-shadow: inset 1px 1px 0 0 rgba(0,0,0,0.05);
  line-height: 1;
  text-align: right;
  font-size: 16px;
}
input[readonly] {
  background-color: #F5F5F5;
}
.calc fieldset input[type="radio"] {
  display: none;
}
.calc fieldset label.auto {
  clear: both;
  width: 100%;
  padding-top: 6px;
  text-align: center;
}
.calc fieldset label.auto > span {
  display: inline-block;
  width: 60px;
  height: 20px;
  margin: 0 auto;
  border: 1px solid #E5E5E5;
  border-radius: 3px;
  text-align: center;
  font-size: 10px;
  line-height: 18px;
}
.calc fieldset label.auto input:checked + span {
  background-color: #EEE;
}
.calc fieldset label.auto > span:before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 8px;
  margin-right: 4px;
  background-color: #FFF;
  border: 1px solid #DDD;
  box-shadow: inset 1px 1px 0 0 rgba(0,0,0,0.05);
  border-radius: 1px;
}
.calc fieldset label.auto input:checked + span:before {
  background-color: #2DE;
}
.calc fieldset label {
  text-align: right;
  line-height: 30px;
}

.simulation {
  padding: 0 20px 20px;
}
.simulation li {
  overflow: hidden;
}
.simulation li label span {
  display: block;
  text-align: center;
  line-height: 30px;
}
.simulation li input.check {
  display: none;
}
.simulation .title li input.check + span {
  white-space: nowrap;
  text-align: left;
  text-indent: -100%;
}
.simulation li input.check + span:before {
  content: '';
  position: absolute;
  display: block;
  width: 14px;
  height: 14px;
  top: 8px;
  left: 0;
  background-color: #FFF;
  border: 1px solid #DDD;
  border-radius: 2px;
}
.simulation li input.check:checked + span:before {
  background-color: #2DE;
  box-shadow: inset 1px 1px 0 0 rgba(0,0,0,0.1);
}
.simulation .title li input.check + span:before {
  top: 16px;
}
.simulation,
.simulation > ul,
.simulation .list_area .set {
  clear: both;
}
.simulation .title li:not(.check) {
  width: 45%;
}
.simulation .title li.check {
  width: 10%;
}
.simulation .title li > h4 {
  height: 25px;
  line-height: 25px;
  text-align: center;
}
.simulation .title li > ul {
  display: -webkit-flex;
  display: flex;
  height: 25px;
}
.simulation .title li > ul li {
  height: 25px;
  padding-top: 5px;
  text-align: center;
}
.simulation .list_area .set {
  padding: 4px 0;
  overflow: hidden;
}
.simulation .title li,
.simulation .list_area .set li {
  padding: 0;
  float: left;
}
.simulation .list_area .set li:not(.check) {
  width: 14.5%;
  margin-left: 0.5%;
}
.simulation .list_area .set li.check {
  width: 10%;
}
.simulation .prev-sales,
.simulation .prev-person,
.simulation .prev-person-sales {
  height: 30px;
  padding: 0 8px;
  background-color: #EEE;
  border: 1px solid #D5D5D5;
  box-shadow: inset 1px 1px 0 0 rgba(0,0,0,0.05);
  border-radius: 3px;
  text-align: right;
  line-height: 28px;
  font-size: 16px;
  color: #555;
}
.list_area input[type="text"] {
  width: 100%;
  height: 30px;
  border: 1px solid #D5D5D5;
}
.btn-area {
  text-align: center;
  padding-top: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/Report/SimulationModal.vue